/**
 * Core dataLayer push utility
 * Checks if GTM is enabled and dataLayer exists before pushing
 */
export const pushToDataLayer = (event, data = {}) => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    console.debug('[Analytics] dataLayer not available', event, data);
    return false;
  }

  window.dataLayer.push({
    event,
    ...data,
    timestamp: new Date().toISOString()
  });

  console.debug('[Analytics] Event pushed:', event, data);
  return true;
};

/**
 * Clear ecommerce data before pushing new ecommerce event
 * (GTM best practice to avoid data bleeding between events)
 */
export const clearEcommerceData = () => {
  if (window.dataLayer) {
    window.dataLayer.push({ ecommerce: null });
  }
};
